/**
 * @generated SignedSource<<6cdd976e120a524e769785db4f736b57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignTxnNatureInputObject = {
  expenseNatureId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type useTxnBulkActions_AssignTxnNatureMutation$variables = {
  input: AssignTxnNatureInputObject;
};
export type useTxnBulkActions_AssignTxnNatureMutation$data = {
  readonly assignTxnNature: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type useTxnBulkActions_AssignTxnNatureMutation = {
  response: useTxnBulkActions_AssignTxnNatureMutation$data;
  variables: useTxnBulkActions_AssignTxnNatureMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTxnBulkActions_AssignTxnNatureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnNatureMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnNature",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTxnBulkActions_AssignTxnNatureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnNatureMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnNature",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91a09771e25e93892dcc0e99967f1c38",
    "id": null,
    "metadata": {},
    "name": "useTxnBulkActions_AssignTxnNatureMutation",
    "operationKind": "mutation",
    "text": "mutation useTxnBulkActions_AssignTxnNatureMutation(\n  $input: AssignTxnNatureInputObject!\n) {\n  assignTxnNature(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d795347d660db9834dbe42c1db34336d";

export default node;
